 /**
  * Is desktop
  *
  * Checks if window is wider than set desktop limit.
  *
  * @return bool is desktop width screen
  */

 function is_desktop() {
	var desktopMinWidth = 720;
	screen_w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	if (screen_w < desktopMinWidth) {
		return false;
	}
	return true;
}

function turnOff(notificationID) {
  sessionStorage.setItem("dontBugMe-id-" + notificationID, true);
}

function turnOn(notificationID) {
	sessionStorage.setItem("dontBugMe-id-" + notificationID, false);
}

function getStatus(notificationID) {
	var status = sessionStorage.getItem("dontBugMe-id-" + notificationID);
	return status;
}

function turnOffForGood() {
 localStorage.setItem('dontBugMe', true);
}


document.addEventListener("DOMContentLoaded", (event) => {
  jQuery(function() {
    // add opacity animation to stop flickering
    jQuery('.hello-notifications').css({ opacity: 1 });

    function visibleNotifications() {
      var visibleNotifications = false;
      jQuery('.hello-notifications__notification').each(function() {

        var notificationID = jQuery(this).attr('id');

        if (getStatus(notificationID) == false || getStatus(notificationID) == null) {
          jQuery(this).addClass('hello-notifications__notification--show');
          visibleNotifications = true;
          jQuery('.hello-notifications').addClass('hello-notifications--show');
        }
      });

      if (!visibleNotifications) {
        jQuery('.hello-notifications').addClass('hello-notifications--hidden');
      }

      return visibleNotifications;
    }

    visibleNotifications();

    // Close a notification
    jQuery('.hello-notifications__close-button').click(function (e) {
      var notificationID = jQuery(this).parent().attr('id');

      turnOff(notificationID);
      jQuery(this).parent().addClass('hello-notifications__notification--hidden');

      visibleNotifications();
    });
  });
});
